import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { AppBar, Toolbar, Divider, Grid, Link } from "@mui/material"
import { styled } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"

import { FiberManualRecord } from "@mui/icons-material"
import HeaderTitle from "atoms/text/HeaderTitle.js"
import HeaderSubText from "atoms/text/HeaderSubText.js"
import HeaderLink from "atoms/button/HeaderLink.js"
import DLoginButton from "molecules/DLoginButton"
import DLogoutButton from "molecules/DLogoutButton"
import HeaderLogo from "molecules/HeaderLogo"
import Menu from "organisms/common/Menu"
import { getTopPagePath } from "locale.js"
import useDAuth from "hooks/useDAuth"

const StyledToolbarTitle = styled(Toolbar)({
  minHeight: "60px !important",
})

const StyledToolbarLogin = styled(Toolbar)({
  minHeight: "50px !important",
})

const LogoutFiberManualRecord = styled(FiberManualRecord)({
  color: "#cc0033",
  height: "12px",
  width: "12px",
})

const Nologin = styled("div")({
  minWidth: "120px",
  height: "18px",
  fontFamily: "HiraKakuProN-W3",
  fontSize: "12px",
  lineHeight: 1.45,
  letterSpacing: "normal",
  color: "#727272",
  paddingRight: "10px",
})

const NewRegist = styled("div")({
  width: "230px",
  height: "18px",
  fontFamily: "HiraKakuProN-W3",
  fontSize: "12px",
  lineHeight: 1.45,
  letterSpacing: "normal",
  color: "#727272",
  paddingLeft: "10px",
})

const NewRegistPhone = styled("div")({
  width: "230px",
  height: "18px",
  fontFamily: "HiraKakuProN-W3",
  fontSize: "12px",
  lineHeight: 1.45,
  letterSpacing: "normal",
  color: "#727272",
})

const NewRegistLink = styled(HeaderLink)({
  width: "176px",
  height: "18px",
  fontFamily: "HiraKakuProN-W3",
  fontSize: "12px",
  lineHeight: 1.45,
  letterSpacing: "normal",
  color: "#3374da",
})

const HeightDivider = styled(Divider)({
  width: "1px",
  height: "18px",
})

const LogoLink = styled(Grid)({
  marginTop: "16px",
  marginBottom: "16px",
})

const StatusLook = styled(Grid)({
  margin: "0",
})

const Header = () => {
  const xs = useMediaQuery("(max-width:734px)")
  const intl = useIntl()

  const registTextStart = intl.formatMessage({ id: "Header.DAccountStart" })
  const registTextLink = intl.formatMessage({ id: "Header.DAccountLink" })
  const registUrlLink = process.env.REACT_APP_D_AUTH_REGIST_URL
  const testId = "headerLinkJa"

  const registUrl = {
    link: registUrlLink,
    linkName: registTextLink,
    id: testId,
  }

  const { isAuthentication } = useDAuth()

  return (
    <AppBar color="inherit" position="relative">
      <StyledToolbarTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Grid container justifyContent="flex-start" alignItems="center">
              <Link href={getTopPagePath()} id="headerLogoLink">
                <LogoLink item>
                  <HeaderLogo />
                </LogoLink>
              </Link>

              {xs ? (
                <></>
              ) : (
                <Grid item id="headerTitle">
                  <HeaderTitle>
                    <FormattedMessage id="Header.Title" />
                  </HeaderTitle>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item>
            <Menu />
          </Grid>
        </Grid>
      </StyledToolbarTitle>
      <Divider />
      <StyledToolbarLogin>
        <Grid container justifyContent="space-between" alignItems="center">
          {xs ? (
            <Grid item>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
                columnSpacing={1}
                wrap="nowrap"
              >
                <Grid item>
                  {isAuthentication ? <></> : <LogoutFiberManualRecord />}
                </Grid>
                <Grid item id="userName">
                  {isAuthentication ? (
                    <></>
                  ) : (
                    <>
                      <HeaderSubText>
                        <FormattedMessage id="Header.NotLogin" />
                      </HeaderSubText>
                      <HeaderSubText> {registTextStart} </HeaderSubText>
                      <HeaderSubText>
                        <NewRegistLink {...registUrl} />
                        <FormattedMessage id="Header.DAccountEnd" />
                      </HeaderSubText>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <Grid item>
              <StatusLook
                container
                justifyContent="flex-start"
                alignItems="center"
                columnSpacing={1}
              >
                <Grid item>
                  {isAuthentication ? <></> : <LogoutFiberManualRecord />}
                </Grid>
                <Grid item id="userName">
                  {isAuthentication ? (
                    <></>
                  ) : (
                    <HeaderSubText>
                      <FormattedMessage id="Header.NotLogin" />
                    </HeaderSubText>
                  )}
                </Grid>
                <Grid item>
                  {isAuthentication ? null : (
                    <HeightDivider orientation="vertical" flexItem />
                  )}
                </Grid>
                <Grid item>
                  {isAuthentication ? null : (
                    <HeaderSubText>
                      {registTextStart}
                      <NewRegistLink {...registUrl} />
                      <FormattedMessage id="Header.DAccountEnd" />
                    </HeaderSubText>
                  )}
                </Grid>
              </StatusLook>
            </Grid>
          )}
          <Grid item>
            {isAuthentication ? <DLogoutButton /> : <DLoginButton />}
          </Grid>
        </Grid>
      </StyledToolbarLogin>
    </AppBar>
  )
}

export default Header
